import React from "react";
import "./information.css";

function Information() {
  return (
    <section className="information-section">
      <div className="information-container">
        <h2 className="information-title">Contact Information</h2>

        <div className="information-grid">
          <div className="info-card">
            <h3>Email</h3>
            <p><a href="mailto:ZacharyOlsonOnline@gmail.com">ZacharyOlsonOnline</a></p>
          </div>

          <div className="info-card">
            <h3>LinkedIn</h3>
            <p><a href="https://www.linkedin.com/in/zack-o-olson/" target="_blank" rel="noopener noreferrer">Zack Olson</a></p>
          </div>

          <div className="info-card">
            <h3>GitHub</h3>
            <p><a href="https://github.com/ZackOlson" target="_blank" rel="noopener noreferrer">ZackOlson</a></p>
          </div>

          <div className="info-card">
            <h3>United States</h3>
            <p>Burlington, Vermont</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Information;